
export class ReportColumnModel {
  Type: number;
  Description: string;
  IsChecked: boolean;
  Name: string;
  Value: string;

  init(data?: any) {
    if (data) {
      this.Type = data["type"];
      this.Description = data["description"];
      this.Name = data["name"];
    }
  }

  static fromJS(data: any): ReportColumnModel {
    data = typeof data === 'object' ? data : {};
    let result = new ReportColumnModel();
    result.init(data);
    return result;
  }
}
